import script from "./ReactionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactionBar.vue?vue&type=script&setup=true&lang=js"

import "./ReactionBar.vue?vue&type=style&index=0&id=fdf0232e&scoped=true&lang=css"
import "./ReactionBar.vue?vue&type=style&index=1&id=fdf0232e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdf0232e"]])

export default __exports__